import { render, staticRenderFns } from "./dialog-move.vue?vue&type=template&id=71fd33cd"
import script from "./dialog-move.vue?vue&type=script&lang=js"
export * from "./dialog-move.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports